export default __webpack_public_path__ + "icon-ios-f1cc5d3fd6ae1a0ef4a5de54c2aa6db5.svg";